angular
  .module("cakeapp")
  .controller(
    "LanguageController",
    ["$scope", "$rootScope", "$translate", "$localStorage", "applicationSettings", function (
      $scope,
      $rootScope,
      $translate,
      $localStorage,
      applicationSettings
    ) {

      $scope.applicationSettings = applicationSettings;

      // set defult values
      $scope.selectedLanguageName = "Language";
      $scope.isLanguageDropdownOpen = false;

      $scope.toggleLanguageDropdown = function () {
        $scope.isLanguageDropdownOpen = !$scope.isLanguageDropdownOpen;
      };

      $scope.toggleLanguage = function (e) {
        e.preventDefault() ;

        $localStorage.language = 
          $localStorage.language === "configuration/languages/en-us.json" 
            ? "configuration/languages/fa-ir.json"
            : "configuration/languages/en-us.json"

        $rootScope.direction =
          $localStorage.language === "configuration/languages/en-us.json"
            ? "ltr"
            : "rtl";

        $rootScope.isRTL =  ($localStorage.language === "configuration/languages/fa-ir.json")

        $translate.use($localStorage.language);

        $rootScope.$broadcast("directionChanged", $rootScope.direction);

      };
    
      $scope.selectLanguage = function ( languageName , languageFileUrl ) {
                
        $scope.clickedLanguage = languageFileUrl ;

        // toggle language if dosent active
        if( $scope.clickedLanguage !==  $localStorage.language){

            $localStorage.language = $scope.clickedLanguage
            $scope.selectedLanguageName = languageName

            $rootScope.direction =
              $localStorage.language === "configuration/languages/en-us.json"
                ? "ltr"
                : "rtl";

            $rootScope.isRTL =  ($localStorage.language === "configuration/languages/fa-ir.json")
            $translate.use($localStorage.language);
    
            $rootScope.$broadcast("directionChanged", $rootScope.direction);
        }

        // close dropdown 
        $scope.toggleLanguageDropdown()
      };

    }]
  );
